module.exports = __webpack_public_path__ + "img/Inline-MasterCard.00213a5.svg";